import { Controller } from "@hotwired/stimulus"
import { get } from "@rails/request.js"

// Connects to data-controller="notifications-infinite-scroll"
export default class extends Controller {
  static values = {
    page: Number
  }

  connect() {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.loadMore()
          }
        })
      },
      { threshold: 0.1 }
    )

    this.observer.observe(this.element)
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  async loadMore() {
    // Prevent multiple loads
    if (this.loading) return
    this.loading = true

    // Stop observing while loading
    this.observer.disconnect()

    await get(`/notifications?page=${this.pageValue}`, {
      responseKind: "turbo-stream"
    })
  }
}
